import { MutationHookOptions, useMutation } from '@apollo/client';

import { UPDATE_UNIT } from './mutations';

export const useUpdateUnit = (options?: MutationHookOptions) => useMutation(UPDATE_UNIT, options);
